import React, { useReducer, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { Chip } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import { Typography } from "@material-ui/core";

import NotificationContext from "../../context/notification-context";
import notificationReducer from "../../reducers/notification-reducer";
import { getNotificationItems } from "../../actions/notification-actions";
import NotificationHolder from "./NotificationHolder";
import Loading from "../shared/Loading";
import { DefaultLayout } from "../shared/component";

import { getIconNotification, getIconNews } from "../../utils/helpers/icon/iconHelper";
import useStyles from "../../styles/components/learningcontent/stylesLearningContents";
import useStylesNotification from "../../styles/components/notification/stylesNotification";

const Notification = () => {
	const classes = useStyles();
	const styles = useStylesNotification();
	const [loading, setLoading] = useState(true);
	const [notificationContext, dispatch] = useReducer(notificationReducer);
	const [notification, setNotification] = useState([]);
	const [showScroll, setShowScroll] = useState(false);
	const history = useHistory();

	useEffect(() => {
		initNotifications();		
		window.addEventListener("scroll", checkScrollTop);

		return () => window.removeEventListener("scroll", checkScrollTop);
	}, []);

	const initNotifications = async () => {
		const response = await getNotificationItems();
		setLoading(false);
		if (response > 200 || response.status === "Failed") {
			return history.push("/SessionTimeOut")
		}

		setNotification(response.data);
	};

	const checkScrollTop = () => {
		if (!showScroll && window.pageYOffset > 400) {
			setShowScroll(true);
		} else if (showScroll && window.pageYOffset <= 400) {
			setShowScroll(false);
		}
	};

	const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
	
	const breadcrumb = () => history.goBack();

	if (loading) return <Loading />;

	return (
		<NotificationContext.Provider value={{ notificationContext, dispatch }}>
			<DefaultLayout
				title="Notification"
				type="Notification"
				description=""
				image={getIconNotification().img_nt_background}
			>
				<Grid container>
					<Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} />
					<Grid
						item
						sm={12}
						md={6}
						className={clsx(classes.rootGridContentContainer, styles.rootGridContent)}
					>
						<Typography variant="h4" classes={{ root: styles.rootTitle }}>
							All notification
            			</Typography>
						{notification &&
							notification.map((item) => (
								<NotificationHolder key={item.id} notification={item} />
							))}
					</Grid>
				</Grid>
				<div className={styles.rootGridButton}>
					<Chip
						onClick={scrollTop}
						style={{ height: 40, display: showScroll ? "flex" : "none" }}
						label={<img src={getIconNews().arrowBack} />}
						className={clsx(styles.btnOnTop, styles.btnCommon)}
					/>
					<Chip
						label={<img src={getIconNews().arrowBackUp} />}
						onClick={() => breadcrumb()}
						className={clsx(styles.btnComeBack, styles.btnCommon)}
					/>
				</div>
			</DefaultLayout>
		</NotificationContext.Provider>
	);
};

export default Notification;